Customer.Dashboard ||= {}

class Customer.Dashboard.TicketDetailsNotesView extends Backbone.View
  className: 'ticket-details-notes'
  template: JST["backbone/templates/customer/ticket/detail/box/ticket_details_notes"]

  initialize: (@options = {}) ->
    @ticket = @options.ticket
    @accountUsers = @options.account_users
    @listenTo(@ticket.get('notes'), 'add', @render)
    @listenTo(@ticket.get('notes'), 'remove', @render)
    @listenTo(@ticket.get('notes'), 'change', @render)

  render: =>
    @$el.html(@template(formatted_notes: @getFormattedNotes()))
    @

  getFormattedNotes: ->
    @ticket.get('notes').map( (note) =>
      {
        id: note.get('id')
        created_at: note.get('created_at')
        author_full_name: @getAuthorFullName(note)
        content: note.get('content')
      }
    )

  getAuthorFullName: (note) ->
    user = @accountUsers[note.get('user_id')]
    if user
      "#{user.first_name} #{user.last_name}"
    else
      'Unknown user'
